// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"h6ty+"};